import { render } from "./JobScore.vue?vue&type=template&id=94b70326"
import script from "./JobScore.vue?vue&type=script&lang=js"
export * from "./JobScore.vue?vue&type=script&lang=js"

import "./JobScore.vue?vue&type=style&index=0&id=94b70326&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__